<template>

    <div class="com-news-list-v-cover-title">
        <ul v-if="list.length">
            <li v-for="item in list">
                <a :href="tplGetDetailLink(item.id)" target="_blank" class="flex">

                    <div class="pic cover-image" :style="tplGetStyle(item)"></div>

                    <div class="text el">{{item.title}}</div>
                </a>
            </li>
        </ul>

        <div v-else style="font-size: 12px; color: #999;">暂无最新活动</div>
    </div>

</template>

<script>
import Utils from "@/utils/utils";

export default {
    props: {
        list: {
            type: Array,
            value: []
        }
    },

    data() {
        return {}
    },

    created() {

    },

    methods: {
        tplGetDetailLink(id) {
            return Utils.getPageUrl('detail', {id})
        },
        tplGetStyle(item){
            return {backgroundImage: `url("${item.covers}")`}
        },
    }

}
</script>

<style lang="less" scoped>

.com-news-list-v-cover-title {
    .cover-image {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }


    li {
        width: 370px;
        height: 186px;
        overflow: hidden;
        position: relative;
        margin-bottom: 24px;

        .pic{
            transition: all 0.3s;
            width: 370px;
            height: 186px;
            overflow: hidden;
        }
    }

    li:hover {
        .pic {
            transform: scale(1.05);
        }
    }

    .text {
        font-size: 18px;
        height: 38px;
        padding-top: 6px;
        background: rgba(0, 0,0, 0.6);
        color: #fff;
        padding-left: 16px;
        position: absolute;
        bottom: 0;
        width: 370px;
    }

}


</style>
